// The header strip scrolls sideways below desktop instead of wrapping. The arrow is
// only useful when some nav items are actually off-screen, which depends on how many
// items there are and how wide their labels render — not on a breakpoint — so it is
// measured. Host component must render `<ul ref="topMenuNav">`.

export default {
  data: () => ({
    topMenuOverflowing: false
  }),

  mounted () {
    window.addEventListener('resize', this.measureTopMenu)
    // Label widths shift once the web fonts swap in.
    document.fonts?.ready?.then(this.measureTopMenu)
    this.measureTopMenu()
  },

  // Items arrive async (mega menu payload) or are spliced in after mount, and
  // TopMenu swaps its whole nav when the mega-menu flag resolves — none of which
  // resizes the window.
  updated () {
    this.measureTopMenu()
  },

  beforeDestroy () {
    this.topMenuObserver?.disconnect()
    window.removeEventListener('resize', this.measureTopMenu)
  },

  methods: {
    measureTopMenu () {
      const nav = this.$refs.topMenuNav

      if (nav !== this.topMenuObservedNav) {
        this.topMenuObserver?.disconnect()
        this.topMenuObservedNav = nav
        if (nav && typeof ResizeObserver !== 'undefined') {
          this.topMenuObserver = this.topMenuObserver || new ResizeObserver(this.measureTopMenu)
          this.topMenuObserver.observe(nav)
        }
      }

      this.topMenuOverflowing = !!nav && nav.scrollWidth > nav.clientWidth + 1
    },

    scrollTopMenu () {
      const nav = this.$refs.topMenuNav
      if (!nav) return
      const step = Math.max(nav.clientWidth * 0.6, 120)
      const atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4
      nav.scrollTo({
        left: atEnd ? 0 : nav.scrollLeft + step,
        behavior: 'smooth'
      })
    }
  }
}
